module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.popupShowFlag) ? _c('div', {
    staticClass: "popupShow"
  }, [_vm._v(_vm._s(_vm.popupShowText))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78c62f12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/commonComponents/popup.vue
// module id = 484
// module chunks = 1